import { create } from "zustand";
import type { OcpPosition, OcpKey } from "../types/cash";

interface OcpState {
  positions: Map<OcpKey, OcpPosition>;
  setSnapshot: (data: OcpPosition[]) => void;
  applyDelta: (upsert: OcpPosition[], removed: OcpKey[]) => void;
  hasBreaches: () => boolean;
  breachedCurrencies: () => OcpPosition[];
}

export const useOcpStore = create<OcpState>((set, get) => ({
  positions: new Map(),
  setSnapshot: (data) => {
    const m = new Map<OcpKey, OcpPosition>();
    for (const p of data) m.set(`${p.entity_id}:${p.currency}` as OcpKey, p);
    set({ positions: m });
  },
  applyDelta: (upsert, removed) => {
    const next = new Map(get().positions);
    for (const k of removed) next.delete(k);
    for (const p of upsert) next.set(`${p.entity_id}:${p.currency}` as OcpKey, p);
    set({ positions: next });
  },
  hasBreaches: () =>
    Array.from(get().positions.values()).some((p) => p.alert_level === "BREACH"),
  breachedCurrencies: () =>
    Array.from(get().positions.values()).filter((p) => p.alert_level === "BREACH"),
}));

export function selectOcpArray(s: OcpState): OcpPosition[] {
  return Array.from(s.positions.values());
}
